import { get } from 'lodash';

import { Observable } from '../rx';
import { IBaseEntityType, IPageJumpRouteState } from '../types';
import { getObservableValue } from './common-utils';

export const AUTO_POPULATE_KEY = 'autoPopulate';

export const getCreateAutoPopulateData = <T = IBaseEntityType>(
  routeState$: Observable<IPageJumpRouteState>,
): T => {
  const routeState = getObservableValue(routeState$);

  return get(routeState, [AUTO_POPULATE_KEY]);
};
